import React from 'react';

import classNames from 'classnames/bind';
import style from './Sticker.scss';
const ctx = classNames.bind(style);

const Sticker = props => (
  <div className={ctx('sticker')}>
    <div className={ctx('sticker-inner')}>{props.children}</div>
  </div>
);

export default Sticker;
